"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasOverrideValue = exports.isSourcePropertyAdapter = exports.isSourceAdapter = exports.isSourceItemAdapter = exports.isSourcePathAdapter = exports.isSourceRootAdapter = void 0;
var source_root_adapter_1 = require("./source-root-adapter");
var source_path_adapter_1 = require("./source-path-adapter");
var source_item_adapter_1 = require("./source-item-adapter");
function isSourceRootAdapter(obj) {
    return obj instanceof source_root_adapter_1.SourceRootAdapter;
}
exports.isSourceRootAdapter = isSourceRootAdapter;
function isSourcePathAdapter(obj) {
    return obj instanceof source_path_adapter_1.SourcePathAdapter;
}
exports.isSourcePathAdapter = isSourcePathAdapter;
function isSourceItemAdapter(obj) {
    return obj instanceof source_item_adapter_1.SourceItemAdapter;
}
exports.isSourceItemAdapter = isSourceItemAdapter;
function isSourceAdapter(obj, allowAnyObject) {
    if (allowAnyObject === void 0) { allowAnyObject = true; }
    if (isSourceRootAdapter(obj))
        return true;
    if (isSourcePathAdapter(obj))
        return true;
    if (isSourceItemAdapter(obj))
        return true;
    if (allowAnyObject && typeof obj === "object")
        return true;
    return false;
}
exports.isSourceAdapter = isSourceAdapter;
function isSourcePropertyAdapter(obj) {
    if (isSourcePathAdapter(obj))
        return true;
    return false;
}
exports.isSourcePropertyAdapter = isSourcePropertyAdapter;
function hasOverrideValue(value, type) {
    if (type === String) {
        return typeof value === "string" && value.length > 0;
    }
    else if (type === Boolean) {
        return typeof value === "boolean";
    }
}
exports.hasOverrideValue = hasOverrideValue;
